export default __webpack_public_path__ + "static/media/garde-corps.ed269234.webp";